import { render, staticRenderFns } from "./ReportPromotion.vue?vue&type=template&id=5e54d05f&"
import script from "./ReportPromotion.vue?vue&type=script&lang=js&"
export * from "./ReportPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports